import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import "./App.css";
import HomePage from "./pages/Home/HomePage";
import Azienda from "./pages/Azienda/Azienda";
import Notizie from "./pages/Notizie/Notizie";
import Prodotti from "./pages/Prodotti/Prodotti";
import ConsulenzaSupporto from "./pages/Prodotti/ConsulenzaSupporto.jsx";
import Lingotti from "./pages/Prodotti/Lingotti";
import CollaboraConNoi from "./pages/CollaboraConNoi/CollaboraConNoi";
import Faq from "./pages/Faq/Faq";
import Contatti from "./pages/Contatti/Contatti";
import Approfondimenti from "./pages/Notizie/ApprofondimentiSingle";
import RassegnaStampa from "./pages/Notizie/RassegnaStampaSingle";
import OroPrestige from "./pages/OroPrestige/OroPrestige";
import GioiellerieB2C from "./pages/OroPrestige/GioiellerieB2C.jsx";
import Staff from "./pages/Azienda/Staff";
import History from "./pages/Azienda/History";
import AreaRiservata from "./pages/AreaRiservata/AreaRiservata";
import ScopriProdotti from "./pages/Prodotti/ScopriProdotti";
import ServiziInclusi from "./pages/Prodotti/ServiziInclusi";
import Servizi2 from "./pages/Azienda/Servizi2.jsx";
import PercheOro from "./pages/Home/PercheOro.jsx";
import NotFound404 from "./pages/NotFound404.jsx";
import Servizi from "./pages/Prodotti/Servizi.jsx";
import DivisionePrivate from "./pages/DivisionePrivate/DivisionePrivate.jsx";
import SingleGioielleria from "./pages/OroPrestige/singleGioielleria/SingleGioielleria.jsx";
import Lottie from "lottie-react";
import loading from "./assets/lottie/loading.json";
import Recensioni from "./pages/Recensioni/Recensioni.jsx";
import Whistleblowing from "./pages/Info/Whistleblowing.jsx";
import Reclami from "./pages/Info/Reclami.jsx";
import RecensioniNegative from "./pages/Info/RecensioniNegative.jsx";
import DomandeFrequenti from "./pages/Info/DomandeFrequenti.jsx";


// landings
import StrategiaPatrimoniale from "./pages/Landing/strategiaPatrimoniale.jsx";

// GTM Push Event
import PageTracker from "./components/GTM/PageTracker";
import Accessibilita from "./pages/Info/Accessibilita.jsx";
import { apiGet } from "./utils/apiPost";
import Affidabilita from "./pages/Info/Affidabilita.jsx";




function RedirectTo({ url }) {
  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return null; // or a loading spinner if you'd like
}

function App() {
  const [rightClickEnabled, setRightClickEnabled] = useState(false);

  function formatToUrlFriendly(text) {
    const cleanedText = text
      .toLowerCase() // Convert to lowercase
      .replace(/ /g, "-") // Replace spaces with hyphens
      .replace(/[àáâãäå]/g, "a") // Replace "à", "á", "â", "ã", "ä", "å" with "a"
      .replace(/[èéêë]/g, "e") // Replace "è", "é", "ê", "ë" with "e"
      .replace(/[ìíîï]/g, "i") // Replace "ì", "í", "î", "ï" with "i"
      .replace(/[òóôõö]/g, "o") // Replace "ò", "ó", "ô", "õ", "ö" with "o"
      .replace(/[ùúûü]/g, "u") // Replace "ù", "ú", "û", "ü" with "u"
      .replace(/[^a-z0-9-_+]/g, "-") // Remove special characters except hyphens and alphanumeric characters
      .replace(/-{2,}/g, "-"); // Remove consecutive hyphens

    if (cleanedText.endsWith("-")) {
      return cleanedText.slice(0, -1);
    }
    return cleanedText;
  }

  useEffect(() => {
    const handleContextMenu = (event) => {
      if (!rightClickEnabled) {
        event.preventDefault();
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "p") {
        setRightClickEnabled(!rightClickEnabled);
      }
    };

    window.addEventListener("contextmenu", handleContextMenu);
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("contextmenu", handleContextMenu);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [rightClickEnabled]);



  return (
    <div className="App">
      {/* <CursorTrail /> */}
      <div id="loading-overlay">
        <div id="lottie-container">
          <Lottie animationData={loading} loop={true} />
        </div>
      </div>
      <PageTracker />

      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/azienda/" element={<Azienda />} />
        <Route
          exact
          path="/perche-scegliere-careisgold/"
          element={<Servizi2 />}
        />
        <Route exact path="/notizie/" element={<Notizie />} />
        <Route exact path="/notizie/rassegna-stampa/" element={<Notizie />} />
        <Route exact path="/notizie/approfondimenti/" element={<Notizie />} />
        <Route exact path="/prodotti-e-servizi/" element={<Prodotti />} />
        <Route
          exact
          path="/consulenza-supporto/"
          element={<ConsulenzaSupporto />}
        />
        <Route exact path="/lingotti/" element={<Lingotti />} />
        <Route exact path="/collabora-con-noi/" element={<CollaboraConNoi />} />
        <Route
          exact
          path="/collabora-con-noi/divisione-prime/"
          element={<CollaboraConNoi />}
        />
        <Route
          exact
          path="/collabora-con-noi/divisione-private/"
          element={<CollaboraConNoi />}
        />
        <Route
          exact
          path="/collabora-con-noi/divisione-corporate/"
          element={<CollaboraConNoi />}
        />
        <Route exact path="/faq/" element={<Faq />} />
        <Route exact path="/faq/categoria/" element={<Faq />} />
        <Route exact path="/contatti/" element={<Contatti />} />
        <Route exact path="/oro-prestige/" element={<GioiellerieB2C />} />
        <Route exact path="/oroprestige/" element={<GioiellerieB2C />} />
        <Route exact path="/staff/" element={<Staff />} />
        <Route exact path="/gruppo/" element={<History />} />
        <Route
          exact
          path="/area-clienti-collaboratori/"
          element={<AreaRiservata />}
        />
        <Route exact path="/prodotti/" element={<ScopriProdotti />} />
        <Route exact path="/servizi-inclusi/" element={<ServiziInclusi />} />
        <Route exact path="/investire-in-oro/" element={<PercheOro />} />
        {/* <Route exact path="/not-found/" element={<NotFound404 />} /> */}
        <Route exact path="/servizi/" element={<Servizi />} />
        <Route
          exact
          path="/divisione-private-consulenti/"
          element={<DivisionePrivate />}
        />
        <Route exact path="/recensioni/" element={<Recensioni />} />
        <Route
          exact
          path="/info/whistleblowing/"
          element={<Whistleblowing />}
        />
        <Route
          exact
          path="/info/reclami/"
          element={<Reclami />}
        />
        {/* <Route
          exact
          path="/info/accessibilita/"
          element={<Accessibilita />}
        /> */}
        <Route
          exact
          path="/fare-chiarezza/"
          element={<Affidabilita />}
        />
        <Route
          exact
          path="/careisgold-recensioni-negative-cosa-dicono-e-cosa-signficano"
          element={<RecensioniNegative />}
        />
        <Route
          exact
          path="/domande-frequenti/"
          element={<DomandeFrequenti />}
        />

        {/* Landing routes */}
        <Route
          exact
          path="/strategia-patrimoniale/"
          element={<StrategiaPatrimoniale />}
        />

        {/* pagina gioiellerie */}
        <Route
          exact
          path="/oro-prestige/:city/:name/"
          element={<SingleGioielleria />}
        />

  
        <Route
            exact
            path={`/notizie/approfondimenti/:id/:title/`}
            element={<Approfondimenti />}
          />

        <Route
            exact
            path={`/notizie/rassegna-stampa/:id/:title/`}
            element={<RassegnaStampa />}
          />

        {/* redirect */}
        <Route
          path="/banco-metalli/"
          element={
            <Navigate
              to="/perche-scegliere-careisgold/"
              replace
            />
          }
        />
        <Route
          path="/certificazione-good-delivery/"
          element={
            <Navigate
              to="/perche-scegliere-careisgold/"
              replace
            />
          }
        />
        <Route
          path="/accreditamenti-certificazioni/"
          element={
            <Navigate
              to="/perche-scegliere-careisgold/"
              replace
            />
          }
        />
        <Route
          path="/careisgold-fondazione-veronesi"
          element={<RedirectTo url="https://beneficenza.careisgold.it/fondazione-veronesi" />}
        />
        <Route
          path="/trattamento-fiscale/"
          element={
            <Navigate
              to="/notizie/approfondimenti/32/guida-alla-tassazione-dell-oro-da-investimento-in-italia-leggi-e-dichiarazioni/"
              replace
            />
          }
        />
        <Route path="/links" element={<RedirectTo url="https://linktree.careisgold.it" />} />
        <Route
          path="/perche-investire-in-oro"
          element={<RedirectTo url="https://investireinoro.careisgold.it/perche-investire-in-oro/?IdOrigin=7" />}
        />
        <Route path="*" element={<NotFound404 />} />
      </Routes>
    </div>
  );
}

export default App;
